"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectQueryBuilderView = exports.SelectQueryBuilder = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const entity_ui_1 = require("@sierralabs/entity-ui");
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const AliasSelector_1 = __importDefault(require("../selectors/AliasSelector"));
const ColumnsSelector_1 = __importDefault(require("../selectors/ColumnsSelector"));
const EntitySelector_1 = __importDefault(require("../selectors/EntitySelector"));
const JoinSelector_1 = __importDefault(require("../selectors/JoinSelector"));
const OrderBySelector_1 = __importDefault(require("../selectors/OrderBySelector"));
const WhereSelector_1 = __importStar(require("../selectors/WhereSelector"));
const StyledDiv = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  &.vertical {
    width: 100%;
    .entity-selector,
    .alias-selector-container,
    .alias-selector,
    .join-selector-container,
    .join-type-selector,
    .join-relation-selector,
    .where-selector-container,
    .column-selector-container,
    .column-selector,
    .expression-field {
      flex: 1 1 auto;
      overflow: hidden;
    }
    .expression-field {
      max-width: 40%;
    }
  }
  .row {
    display: flex;
    align-items: flex-start;
    margin: 4px 0;
    &.join-selector-row {
      display: block;
      .select-query-builder {
        margin-top: 8px;
        margin-bottom: 16px;
        margin-left: 20px;
        padding-left: 16px;
        border-left: 3px dashed ${props => props.theme.palette.grey[300]};
      }
    }
  }

  .separator {
    display: inline-block;
    padding: 4px 6px;
  }
`;
const SelectQueryBuilder = props => {
    return react_1.default.createElement(exports.SelectQueryBuilderView, Object.assign({}, props));
};
exports.SelectQueryBuilder = SelectQueryBuilder;
exports.default = exports.SelectQueryBuilder;
const SelectQueryBuilderView = ({ configPath = 'config', selectLabel = 'Select', fromLabel = 'From', whereLabel = 'Where', groupByLabel = 'Group By', orderByLabel = 'Order By', hide = [], vertical }) => {
    var _a, _b, _c, _d;
    const { entities } = (0, entity_ui_1.useEntityContext)();
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const [query, setQuery] = (0, react_1.useState)(queryManager.query);
    // use subquery config or main config
    const config = configPath
        ? queryManager.get(configPath)
        : query.config;
    const initialWheres = config === null || config === void 0 ? void 0 : config.wheres;
    const [wheres, setWheres] = (0, react_1.useState)(initialWheres || []);
    const { tablePath } = (config === null || config === void 0 ? void 0 : config.mainAlias) || {};
    const classes = ['select-query-builder'];
    if (vertical)
        classes.push('vertical');
    // get cached column maps or get using subquery config
    const queryAliasColumnMap = (0, react_1.useMemo)(() => {
        return !configPath || configPath === 'config'
            ? queryManager.queryAliasColumnMap
            : queryManager.getQueryAliasColumnMap(config);
        // re-evaluate when queryManager.queryAliasColumnMap changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config, configPath, queryManager, queryManager.queryAliasColumnMap]);
    const fromEntity = (0, react_1.useMemo)(() => {
        return tablePath
            ? entities === null || entities === void 0 ? void 0 : entities.find(e => e.tableName === tablePath)
            : undefined;
    }, [entities, tablePath]);
    (0, react_1.useEffect)(() => {
        initialWheres && setWheres(initialWheres);
    }, [initialWheres]);
    (0, react_1.useEffect)(() => {
        const handleChange = () => {
            setQuery(Object.assign({}, queryManager.query));
        };
        handleChange();
        queryManager.subscribe('change', handleChange);
        return () => {
            queryManager.unsubscribe('change', handleChange);
        };
    }, [queryManager]);
    return (react_1.default.createElement(StyledDiv, { className: classes.join(' ') },
        !hide.includes('select') && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Typography, { variant: 'overline' }, selectLabel),
            react_1.default.createElement("div", { className: 'row' },
                react_1.default.createElement(ColumnsSelector_1.default, { multiple: true, config: config, vertical: vertical, queryAliasColumnMap: queryAliasColumnMap, value: ((_a = config === null || config === void 0 ? void 0 : config.selects) === null || _a === void 0 ? void 0 : _a.map(s => s.selection)) || [], onColumnChange: (selection, index, columnMap) => {
                        // set pluginType similar to SelectQueryBuilder2
                        const select = { selection };
                        if (columnMap === null || columnMap === void 0 ? void 0 : columnMap.plugin) {
                            select.pluginType = columnMap.plugin.type;
                        }
                        queryManager.updateSelect(index, select, `${configPath}.selects`);
                    }, onMove: (sourceIndex, targetIndex) => queryManager.moveSelect(sourceIndex, targetIndex, `${configPath}.selects`), onDelete: index => queryManager.deleteSelect(index, `${configPath}.selects`) })))),
        !hide.includes('from') && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Typography, { variant: 'overline' }, fromLabel),
            react_1.default.createElement("div", { className: 'row' },
                react_1.default.createElement(EntitySelector_1.default, { value: fromEntity, onChange: entity => queryManager.updateFrom(entity, configPath) }),
                fromEntity && (react_1.default.createElement(AliasSelector_1.default, { entity: fromEntity, value: (_b = config === null || config === void 0 ? void 0 : config.mainAlias) === null || _b === void 0 ? void 0 : _b.name, onChange: value => queryManager.updateFromAlias(value, `${configPath}.mainAlias.name`) }))), (_c = config === null || config === void 0 ? void 0 : config.joinAttributes) === null || _c === void 0 ? void 0 :
            _c.map((joinAttribute, index) => (react_1.default.createElement("div", { className: 'row join-selector-row', key: index },
                react_1.default.createElement(JoinSelector_1.default, { index: index, vertical: vertical, configPath: configPath, joinAttribute: joinAttribute })))),
            react_1.default.createElement("div", { className: 'row' },
                react_1.default.createElement(core_1.Button, { size: 'small', variant: 'outlined', endIcon: react_1.default.createElement(core_1.Icon, null, "add"), onClick: () => {
                        queryManager.addJoin({ direction: 'LEFT' }, `${configPath}.joinAttributes`);
                    } }, "Add Join")))),
        !hide.includes('where') && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Typography, { variant: 'overline' }, whereLabel),
            wheres.map((where, index) => (react_1.default.createElement("div", { className: 'row', key: (0, WhereSelector_1.generateWhereKey)(wheres, index) },
                react_1.default.createElement(WhereSelector_1.default, { vertical: vertical, where: where, queryAliasColumnMap: queryAliasColumnMap, onChange: where => {
                        queryManager.updateWhere(index, where, `${configPath}.wheres`);
                    }, onDelete: () => {
                        // const wheres = query.config?.wheres || [];
                        const wheresPath = `${configPath}.wheres`;
                        const wheres = queryManager.get(wheresPath);
                        if (index < wheres.length) {
                            queryManager.deleteWhere(index, wheresPath);
                            if (index === 0 && wheres.length > 0) {
                                queryManager.updateWhereType(index, 'simple', wheresPath);
                            }
                            setWheres([...wheres]);
                        }
                        else {
                            // this is needed when adding a where clause; if the where
                            // clause is not validated it will not be in the
                            // trackChanges instance.
                            setWheres(wheres => {
                                wheres.splice(index, 1);
                                return [...wheres];
                            });
                        }
                    } })))),
            (wheres.length === 0 ||
                wheres.length === ((_d = config === null || config === void 0 ? void 0 : config.wheres) === null || _d === void 0 ? void 0 : _d.length)) && (react_1.default.createElement("div", { className: 'row' },
                react_1.default.createElement(core_1.Button, { size: 'small', variant: 'outlined', endIcon: react_1.default.createElement(core_1.Icon, null, "add"), onClick: () => {
                        // when adding don't save to query just modify the `wheres`
                        // state so that the user can edit and validate before saving
                        setWheres([
                            ...wheres,
                            { type: !(wheres === null || wheres === void 0 ? void 0 : wheres.length) ? 'simple' : 'and' }
                        ]);
                    } }, "Add Filter"))))),
        !hide.includes('groupBy') && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Typography, { variant: 'overline' }, groupByLabel),
            react_1.default.createElement("div", { className: 'row' },
                react_1.default.createElement(ColumnsSelector_1.default, { freesolo: true, multiple: true, config: config, vertical: vertical, value: (config === null || config === void 0 ? void 0 : config.groupBys) || [], queryAliasColumnMap: queryAliasColumnMap, onDelete: index => {
                        queryManager.deleteGroupBy(index, `${configPath}.groupBys`);
                    }, onMove: (sourceIndex, targetIndex) => {
                        queryManager.moveGroupBy(sourceIndex, targetIndex, `${configPath}.groupBys`);
                    }, onColumnChange: (value, index) => {
                        queryManager.updateGroupBy(index, value, `${configPath}.groupBys`);
                    } })))),
        !hide.includes('orderBy') && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Typography, { variant: 'overline' }, orderByLabel),
            (config === null || config === void 0 ? void 0 : config.orderBys) &&
                Array.isArray(config.orderBys) &&
                config.orderBys.map((orderBy, index) => (react_1.default.createElement("div", { className: 'row', key: index },
                    react_1.default.createElement(OrderBySelector_1.default, { config: config, orderBy: orderBy, vertical: vertical, queryAliasColumnMap: queryAliasColumnMap, 
                        // configPath={`${configPath}.orderBys[${index}]`}
                        onDelete: () => queryManager.deleteOrderBy(index, `${configPath}.orderBys`), onChangePropertyPath: value => queryManager.updateOrderByPropertyPath(index, value, `${configPath}.orderBys`), onChangeOrder: value => queryManager.updateOrderByDirection(index, value, `${configPath}.orderBys`), onChangeNulls: value => queryManager.updateOrderByNulls(index, value, `${configPath}.orderBys`) })))),
            react_1.default.createElement("div", { className: 'row' },
                react_1.default.createElement(core_1.Button, { size: 'small', variant: 'outlined', endIcon: react_1.default.createElement(core_1.Icon, null, "add"), onClick: () => {
                        queryManager.addOrderBy({ propertyPath: '', order: 'ASC' }, `${configPath}.orderBys`);
                    } }, "Add Order By"))))));
};
exports.SelectQueryBuilderView = SelectQueryBuilderView;
//# sourceMappingURL=SelectQueryBuilder.js.map